import { Routers } from './components/Routers/Routers';
import './App.css';

function App() {


  return (
    <div className='App'>


        <Routers/>
       
    

    </div>
  );
}

export default App;
